import { type FC } from 'react';
import { Group, Image, type MantineSize, Text } from '@mantine/core';
import { useUnit } from 'effector-react';
import { $banksMap } from '~/entities/bank';

interface BankIdentityProps {
    bankCode?: string;
    size?: MantineSize;
}

export const BankIdentity: FC<BankIdentityProps> = ({ bankCode, size = 'sm' }) => {
    const banksMap = useUnit($banksMap);
    const bank = bankCode ? banksMap.get(bankCode) : undefined;

    if (!bankCode) {
        return null;
    }

    const logoUrl = bank?.logo_url;
    const label = bank?.name_ru ?? bankCode;

    return (
        <Group
            gap={4}
            wrap='nowrap'
        >
            {logoUrl && (
                <Image
                    src={logoUrl}
                    bdrs='md'
                    alt={label}
                    decoding='async'
                    fit='contain'
                    loading='lazy'
                    referrerPolicy='no-referrer'
                    w={20}
                    h={20}
                />
            )}

            <Text
                component='span'
                size={size}
            >
                {label}
            </Text>
        </Group>
    );
};
